module.exports = __webpack_public_path__ + "static/media/SpeakerUp.bbe96813.svg";